// services/loanService.js
import axios from 'axios';
import { supabase } from "../supabaseClient";

export const getLoanRates = async () => {
  console.log("Fetching loan rates...");

  return new Promise((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_PAYMENT_LINK_URL}api/home-loan-rates`)  // API endpoint for loan rates
      .then((response) => {
        console.log("Loan rates fetched successfully:", response.data);

        if (response.data.success) {
          resolve(response.data.data); // Resolve with loan rates data
        } else {
          console.error('Error fetching loan rates:', response.data.message);
          resolve([]); // Return an empty array in case of failure
        }
      })
      .catch((error) => {
        console.error('Error fetching loan rates:', error);
        reject(error); // Reject the promise on error
      });
  });
};

async function getHomeLoanRates() {
  try {
    // Query the 'HomeLoanInterestRates' table to fetch all rows
    const { data, error } = await supabase
      .from("HomeLoanInterestRates")  // Table name
      .select("*");  // Select all columns

    if (error) {
      throw error;  // Handle error if there's any
    }

    // Log the fetched data
    console.log("Fetched loan rates:", data);
    return data;
  } catch (err) {
    console.error("Error fetching loan rates:", err.message);
    return [];
  }
}
export { getHomeLoanRates };

export const sendLoanInquiry = async (data) => {
  try {
    // Make a POST request to save the loan inquiry
    const response = await axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}api/submit-loan-inquiry`, data);
    return response.data;  // Return the response data from the backend (e.g., success message)
  } catch (error) {
    console.error("Error submitting loan inquiry:", error);
    throw error; // Rethrow error if API call fails
  }
};

